import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProfilInfo, UpdateProfile, UpdatePassword, ChangeImage, Logout, envoyercomptable, Updaterib } from "../services/LoginService";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import { IoMdLogOut } from "react-icons/io";

import "react-toastify/dist/ReactToastify.css";
import * as LoadingIcons from "react-loading-icons";
import UserAbonnement from "./UserAbonnement";
import SubscriptionPlans from "./SubscriptionPlans";
import { useLocation } from "react-router-dom";
const optionsJuridiques = ["Auto-entrepreneur", "SARL", "SAS", "SASU", "EURL", "SA", "Association"];
const optionsDevise = ["€", "$"];
const Profil = () => {
  const token = localStorage.getItem("authTokenUtilisateur");
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [buttonribLoading, setButtonribLoading] = useState(false);
  const [isEditingRib, setIsEditingRib] = useState(false);

  const [emailComptable, setEmailComptable] = useState("");
  const [rib, setRib] = useState(null);
  const [form, setForm] = useState({
    nom_commercial: "",
    forme_juridique: "",
    tva_inclus: false,
    tva_rates: { "10%": false, "20%": false, "5.5%": false },
    capital: "",
    numero_tva: "",
    adresse_ligne1: "",
    adresse_ligne2: "",
    code_postal: "",
    ville: "",
    current_plan: "",
    logo_inclus_pdf: false,
    devise: "€",
  });

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const location = useLocation();
  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message);
      // Remove the state so toast doesn’t show again on reload
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);
  // Chargement du profil
  useEffect(() => {
    if (!token) return navigate("/login");
    (async () => {
      try {
        const res = await ProfilInfo(token);
        if (res.success && res.user) {
          const u = res.user;

          // Transformer tva_rates string en objet si besoin
          let tvaRatesObj = { "10%": false, "20%": false, "5.5%": false, "2.1%": false };
          if (typeof u.tva_rates === "string") {
            u.tva_rates.split("#").forEach(item => {
              const match = item.match(/(\d+(\.\d+)?%)(true|false)/);
              if (match) tvaRatesObj[match[1]] = match[3] === "true";
            });
          } else if (typeof u.tva_rates === "object") {
            tvaRatesObj = u.tva_rates;
          }

          setForm({
            nom_commercial: u.nom_commercial || "",
            forme_juridique: u.forme_juridique || "",
            tva_inclus: u.tva_inclus ?? false,
            tva_rates: tvaRatesObj,
            capital: u.capital || "",
            numero_tva: u.numero_tva || "",
            adresse_ligne1: u.adresse_ligne1 || "",
            adresse_ligne2: u.adresse_ligne2 || "",
            code_postal: u.code_postal || "",
            ville: u.ville || "",
            current_plan: u.current_plan || "",
            logo_inclus_pdf: u.logo_inclus_pdf ?? false,
            devise: u.devise || "€",
          });
          setUser(u);
        } else {
          toast.error(res.message || "Erreur lors du chargement du profil");
        }
      } catch (err) {
        console.error(err);
        toast.error("Erreur lors du chargement du profil.");
      } finally {
        setLoading(false);
      }
    })();
  }, [token, navigate]);

  // Gestion champs
  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleTvaInclusChange = e => {
    const checked = e.target.checked;
    setForm(prev => ({
      ...prev,
      tva_inclus: checked,
      tva_rates: checked ? prev.tva_rates : { "10%": false, "20%": false, "5.5%": false, "2.1%": false },
    }));
  };

  const handleTauxChange = taux => {
    setForm(prev => ({ ...prev, tva_rates: { ...prev.tva_rates, [taux]: !prev.tva_rates[taux] } }));
  };

  const handleUpdaterib = async (e) => {
    e.preventDefault();
    setButtonribLoading(true);
    try {
      const res = await Updaterib(token, rib);
      if (res.success) {
        toast.success(res.message || "IBAN mis à jour ✅");

        // mettre à jour localement pour feedback instantané
        setUser(prev => ({ ...prev, rib: res.rib }));

        setIsEditingRib(false);
        setRib("");

        // recharger la page après 2 secondes
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        toast.error(res.message || "Erreur lors du changement de IBAN");
      }
    } catch {
      toast.error("Erreur lors du changement de IBAN");
    } finally {
      setButtonribLoading(false);
    }
  };

  // Mise à jour du profil
  const handleUpdateProfile = async e => {
    e.preventDefault();
    setButtonLoading(true);

    if (!form.forme_juridique) {
      toast.error("Veuillez sélectionner une forme juridique.");
      setButtonLoading(false);
      return;
    }
    if (form.tva_inclus && !Object.values(form.tva_rates).some(v => v)) {
      toast.error("Veuillez cocher au moins un taux TVA.");
      setButtonLoading(false);
      return;
    }

    try {
      // ⚡ Convertir l'objet tva_rates en string "10%true#20%false#5.5%true"
      const tvaString = Object.entries(form.tva_rates)
        .map(([k, v]) => `${k}${v ? "true" : "false"}`)
        .join("#");

      const payload = {
        nom_commercial: form.nom_commercial || "",
        forme_juridique: form.forme_juridique || "",
        capital: form.capital || "",
        tva_inclus: !!form.tva_inclus,
        tva_rates: tvaString,  // 🔹 format backend
        numero_tva: form.numero_tva || "",
        adresse_ligne1: form.adresse_ligne1 || "",
        adresse_ligne2: form.adresse_ligne2 || "",
        code_postal: form.code_postal || "",
        ville: form.ville || "",
        devise: form.devise || "€",
        logo_inclus_pdf: !!form.logo_inclus_pdf,
      };

      console.log("Payload envoyé :", payload); // 🔹 debug

      const res = await UpdateProfile(token, payload);
      if (res.success && res.user) {
        setUser(res.user);
        toast.success(res.message || "Profil mis à jour ✅");
      } else {
        toast.error(res.message || "Erreur lors de la mise à jour du profil");
      }
    } catch (err) {
      console.error(err);
      toast.error("Erreur lors de la mise à jour du profil");
    } finally {
      setButtonLoading(false);
    }
  };

  // Changer mot de passe
  const handleUpdatePassword = async e => {
    e.preventDefault();
    setButtonLoading(true);
    try {
      const res = await UpdatePassword(token, oldPassword, newPassword);
      if (res.success) toast.success(res.message || "Mot de passe changé ✅");
      else toast.error(res.message || "Erreur lors du changement de mot de passe");
    } catch {
      toast.error("Erreur lors du changement de mot de passe");
    } finally {
      setButtonLoading(false);
      setOldPassword("");
      setNewPassword("");
    }
  };

  // Invitation comptable
  const handleInviteComptable = async (e) => {
    e.preventDefault();
    setButtonLoading(true);

    try {
      const res = await envoyercomptable(emailComptable, token);

      if (res.success) {
        // Afficher le toast
        toast.success(res.message || "Invitation envoyée ✅");

        // Actualiser la page après 30 secondes
        setTimeout(() => {
          window.location.reload();
        }, 30000); // 30 000 ms = 30 secondes
      } else {
        toast.error(res.message || "Erreur lors de l'envoi de l'invitation");
      }
    } catch (err) {
      toast.error("Erreur inattendue lors de l'envoi");
    } finally {
      setButtonLoading(false);
      setEmailComptable("");
    }
  };


  // Changer image
  const handleImageChange = async e => {
    const file = e.target.files[0];
    if (!file) return;
    setButtonLoading(true);
    try {
      const res = await ChangeImage(token, file);
      if (res.success && res.imageUrl) setUser(prev => ({ ...prev, photo_profil: res.imageUrl }));
    } catch {
      toast.error("Erreur lors du changement d'image");
    } finally {
      setButtonLoading(false);
    }
  };

  // Déconnexion
  const handleLogout = async () => {
    setButtonLoading(true);
    try {
      await Logout(token);
      localStorage.removeItem("authTokenUtilisateur");
      navigate("/login");
    } finally {
      setButtonLoading(false);
    }
  };

  // ⚡ Débogage : affichage du user
  //  console.log("USER:", user);
  const handleFormeJuridiqueChange = (e) => {
    const value = e.target.value;

    setForm((prev) => ({
      ...prev,
      forme_juridique: value,
      tva_inclus: value === "Auto-entrepreneur" ? prev.tva_inclus : true, // ⚡ Forcer à true sinon
    }));
  };

  return (
    <div className="w-full lg:mx-auto lg:p-8 lg:mb-0 mb-10 relative">
      {loading && (
        <div className="absolute inset-0 h-screen bg-white bg-opacity-75 flex flex-col justify-center items-center z-50 rounded-lg">
          <LoadingIcons.SpinningCircles stroke="#2218eeff" fill="#2218eeff" strokeWidth={3} height={50} width={50} />
          <p>Chargement...</p>
        </div>
      )}

      {user && (
        <div className="bg-color2 lg:p-8 p-2 rounded-lg shadow-lg relative">
          {buttonLoading && (
            <div className="absolute inset-0 bg-white bg-opacity-75 flex justify-center items-center z-50 rounded-lg">
              <LoadingIcons.SpinningCircles stroke="#1A2A6C" height={50} width={50} />
            </div>
          )}
          {/* Header profil */}
          <div className="mb-6">
            <div className="flex flex-row justify-between items-center mb-6">
              <h2 className="text-xl font-bold text-color6 lg:mb-4">📌 Informations personnelles</h2>
              <IoMdLogOut onClick={handleLogout} size={26} className="text-white bg-color16 rounded-full p-1 lg:hidden block" />
            </div>

            <div className="flex justify-between items-center lg:mb-6 mb-1">
              <div className="flex flex-row items-center lg:gap-6 gap-4">
                <div className="relative group lg:w-28 lg:h-28 w-28 h-28">
                  <div className="lg:w-28 lg:h-28 w-28 h-28 rounded-full overflow-hidden bg-color6 flex items-center justify-center text-white text-2xl font-bold">
                    {user.photo_profil ? (
                      <img
                        src={user.photo_profil}
                        alt="Profil"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <span>
                        {user.nom_complet
                          ? user.nom_complet
                            .split(" ")
                            .map((n) => n[0]?.toUpperCase())
                            .join("")
                            .slice(0, 2)
                          : "?"}
                      </span>
                    )}
                  </div>

                  <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 cursor-pointer transition-opacity rounded-full">
                    <label className="text-white font-semibold cursor-pointer">
                      Modifier
                      <input type="file" accept="image/*" className="hidden" onChange={handleImageChange} />
                    </label>
                  </div>
                </div>
                <div className="lg:hidden flex flex-col  gap-2">
                  <h3 className=" text-xl font-semibold text-color1">{user.nom_complet}</h3>
                  <span className="font-bold text-sm">{user.email}</span>
                  <span className="font-bold text-sm">{user.telephone || "-"}</span>
                  <span className="font-bold text-xs">{user.siret || "-"}</span>
                  {user.current_plan === "basic" && (
                    <div className="flex flex-row  items-end justify-start w-full gap-1">
                      {/* Plan actuel */}
                      <p className="text-xs font-semibold capitalize bg-color1 text-color2 rounded-lg px-4 py-2 inline-block shadow-md">
                        {user.current_plan}
                      </p>

                      {/* Bouton Améliorer */}
                      <button
                        onClick={() => {
                          const element = document.getElementById("plan");
                          if (element) element.scrollIntoView({ behavior: "smooth" });
                        }}
                        className="text-xs font-semibold capitalize bg-color3 text-color2 rounded-lg px-4 py-2 inline-block shadow-md hover:bg-color3/80 transition"
                      >
                        Améliorer le plan
                      </button>
                    </div>
                  )}
                </div>

                <div className="lg:flex lg:flex-col hidden gap-2">
                  <h3 className="text-xl font-semibold text-color1">{user.nom_complet}</h3>
                  <div className="flex gap-6 text-color6">
                    <div className="flex flex-col"><span className="font-bold">Email</span><span>{user.email}</span></div>
                    <div className="flex flex-col"><span className="font-bold">SIRET</span><span>{user.siret || "-"}</span></div>
                    <div className="flex flex-col"><span className="font-bold">Téléphone</span><span>{user.telephone || "-"}</span></div>
                  </div>
                  {user.current_plan === "basic" && (
                    <div className="flex flex-col sm:flex-row items-start gap-3">
                      {/* Plan actuel */}
                      <p className="text-lg font-semibold capitalize bg-color1 text-color2 rounded-lg px-4 py-2 inline-block shadow-md">
                        {user.current_plan}
                      </p>

                      {/* Bouton Améliorer */}
                      <button
                        onClick={() => {
                          const element = document.getElementById("plan");
                          if (element) element.scrollIntoView({ behavior: "smooth" });
                        }}
                        className="text-lg font-semibold capitalize bg-color3 text-color2 rounded-lg px-4 py-2 inline-block shadow-md hover:bg-color3/80 transition"
                      >
                        Améliorer le plan
                      </button>
                    </div>
                  )}

                </div>

              </div>
              <button onClick={handleLogout} className="bg-color16 lg:block hidden hover:bg-red-600 text-color2 px-4 py-2 rounded shadow-md">Déconnexion</button>
            </div>


          </div>
          <div className="w-full">
            {user.current_plan === "basic" ? (
              <></>
            ) : (
              <hr className="border-t border-gray-300 my-6" />
              &&
              <UserAbonnement user={user} token={token} />
            )}
          </div>
          <hr className="border-t border-gray-300 my-6" />
          {/* Formulaire profil */}
          <div className="mb-6">
            <h2 className="text-xl font-bold text-color6 mb-4">📝 Informations de l’entreprise</h2>
            <form
              onSubmit={handleUpdateProfile}
              className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6 px-2 sm:px-4"
            >
              {/* Nom commercial */}
              <div className="flex flex-col">
                <label className="text-sm font-semibold mb-1">Nom commercial</label>
                <input
                  type="text"
                  name="nom_commercial"
                  value={form.nom_commercial}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2 text-sm sm:text-base"
                />
              </div>

              {/* Forme juridique */}
              <div className="flex flex-col">
                <label className="text-sm font-semibold mb-1">Forme juridique</label>
                <select
                  name="forme_juridique"
                  value={form.forme_juridique}
                  onChange={handleFormeJuridiqueChange}
                  className="w-full border rounded px-3 py-2 text-sm sm:text-base"
                  required
                >
                  <option value="">-- Choisir --</option>
                  {optionsJuridiques.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>

              {/* Capital */}
              <div className="flex flex-col">
                <label className="text-sm font-semibold mb-1">Capital</label>
                <input
                  type="text"
                  name="capital"
                  value={form.capital}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2 text-sm sm:text-base"
                />
              </div>

              {/* Adresse ligne 1 */}
              <div className="flex flex-col">
                <label className="text-sm font-semibold mb-1">Adresse ligne 1</label>
                <input
                  type="text"
                  name="adresse_ligne1"
                  value={form.adresse_ligne1}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2 text-sm sm:text-base"
                />
              </div>

              {/* Complément d'adresse */}
              <div className="flex flex-col">
                <label className="text-sm font-semibold mb-1">Complément d'adresse</label>
                <input
                  type="text"
                  name="adresse_ligne2"
                  value={form.adresse_ligne2}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2 text-sm sm:text-base"
                />
              </div>

              {/* Code postal */}
              <div className="flex flex-col">
                <label className="text-sm font-semibold mb-1">Code postal</label>
                <input
                  type="number"
                  name="code_postal"
                  value={form.code_postal}
                  onChange={handleChange}
                  min={0}
                  max={99999}
                  onInput={(e) => (e.target.value = e.target.value.slice(0, 5))}
                  className="w-full border rounded px-3 py-2 text-sm sm:text-base"
                />
              </div>

              {/* Ville */}
              <div className="flex flex-col">
                <label className="text-sm font-semibold mb-1">Ville</label>
                <input
                  type="text"
                  name="ville"
                  value={form.ville}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2 text-sm sm:text-base"
                />
              </div>

              {/* Devise */}
              <div className="flex flex-col">
                <label className="text-sm font-semibold mb-1">Devise</label>
                <select
                  name="devise"
                  value={form.devise}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2 text-sm sm:text-base"
                >
                  {optionsDevise.map((d) => (
                    <option key={d} value={d}>
                      {d}
                    </option>
                  ))}
                </select>
              </div>

              {/* Section TVA */}
              <div className="col-span-1 sm:col-span-2 mt-4">
                <h3 className="text-lg font-semibold text-color6 mb-2">TVA</h3>

                {/* Choix TVA */}
                {form.forme_juridique === "Auto-entrepreneur" ? (
                  <label className="flex items-center gap-2 mb-3">
                    <input
                      type="checkbox"
                      checked={form.tva_inclus}
                      onChange={handleTvaInclusChange}
                    />
                    TVA incluse
                  </label>
                ) : form.forme_juridique ? (
                  <label className="flex items-center gap-2 mb-3">
                    <input type="checkbox" checked={true} disabled />
                    TVA incluse (obligatoire pour votre statut)
                  </label>
                ) : (
                  <label className="flex items-center gap-2 mb-3">
                    <input type="checkbox" checked={false} disabled />
                    TVA incluse
                  </label>
                )}

                {/* Taux de TVA */}
                {form.tva_inclus && (
                  <div className="flex flex-wrap gap-4 mt-2">
                    {Object.keys(form.tva_rates)
                      .sort((a, b) => parseFloat(a) - parseFloat(b))
                      .map((taux) => (
                        <label key={taux} className="flex items-center gap-1">
                          <input
                            type="checkbox"
                            checked={!!form.tva_rates[taux]}
                            onChange={() => handleTauxChange(taux)}
                          />
                          {taux}
                        </label>
                      ))}
                  </div>
                )}
              </div>

              {/* Bouton sauvegarder */}
              <div className="col-span-1 sm:col-span-2 flex justify-start mt-4">
                <button
                  type="submit"
                  className="bg-color1 text-white text-base sm:text-lg font-bold px-6 py-2 rounded-full w-full sm:w-auto"
                >
                  {buttonLoading ? "Sauvegarde..." : "Sauvegarder"}
                </button>
              </div>
            </form>

          </div>
          <hr className="border-t border-gray-300 my-6" />
          {/* Mot de passe */}
          <div className="mb-6">
            <h2 className="text-xl font-bold text-color6 mb-4">🔒 Mot de passe</h2>
            <form onSubmit={handleUpdatePassword} className="flex flex-col gap-4 mb-6 lg:w-2/3 w-full max-w-sm">
              <div className="relative">
                <label className="block mb-1 font-medium">Ancien mot de passe</label>
                <input
                  type={showOldPassword ? "text" : "password"}
                  value={oldPassword}
                  onChange={e => setOldPassword(e.target.value)}
                  className="w-full  border rounded px-3 py-2"
                />
                <span
                  className="absolute right-3 top-10 cursor-pointer"
                  onClick={() => setShowOldPassword(!showOldPassword)}
                >
                  {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <div className="relative  ">
                <label className="block mb-1 font-medium">Nouveau mot de passe</label>
                <input
                  type={showNewPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  className="w-full border rounded px-3 py-2"
                />
                <span
                  className="absolute right-3 top-10 cursor-pointer"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>


              <div className="flex justify-start">
                <button type="submit" className="bg-color15 text-white lg:text-lg text-base  font-bold  px-6 py-2 rounded-full">{buttonLoading ? "Modification..." : "Modifier"}</button>
              </div>
            </form>
          </div>
          <hr className="border-t border-gray-300 my-6" />
          {/* Comptable invité */}
          <div className="mb-6">
            <h2 className="text-xl font-bold text-blue-600 mb-4">👔 Comptable invité</h2>
            <div className="w-full mx-auto py-6 bg-white   flex flex-col gap-4">

              {/* ⚠️ Affichage état actuel du comptable */}
              {user.email_comptable ? (
                <div className="p-4 bg-gray-100 rounded-md flex flex-col gap-2">
                  <p><span className="font-semibold text-black">Email du comptable :</span> <span className="text-black">{user.email_comptable}</span></p>
                  {user.comptable_status.connecte ? (
                    <p className="text-green-600 font-medium">✅ Comptable connecté</p>
                  ) : (
                    <p className="text-yellow-600 font-medium">📧 Invitation envoyée, en attente de connexion</p>
                  )}
                </div>
              ) : (
                <p className="text-gray-500">Aucun comptable invité pour le moment</p>
              )}

              {/* Formulaire invitation */}
              <div className="mt-4">
                <h3 className="text-lg font-semibold text-blue-600 mb-2">Envoyer une nouvelle invitation</h3>
                <form onSubmit={handleInviteComptable} className="flex flex-col gap-4 lg:w-2/3 w-full max-w-sm">
                  <div className="relative">
                    <label className="block mb-1 font-medium text-black">Email du comptable</label>
                    <input
                      type="email"
                      placeholder="ex: comptable@exemple.com"
                      value={emailComptable}
                      onChange={(e) => setEmailComptable(e.target.value)}
                      className="  w-full border rounded px-3 py-2"
                      required
                    />
                  </div>

                  <div className="flex justify-start">
                    <button
                      type="submit"
                      className="bg-color3 text-white lg:text-lg text-base  font-bold  px-6 py-2 rounded-full"

                      disabled={buttonLoading}
                    >
                      {buttonLoading ? "Envoi..." : "Envoyer l'invitation"}
                    </button>
                  </div>
                </form>
              </div>
              <hr className="border-t border-gray-300" />


            </div>
          </div>
          {/* Section RIB Facture */}
          <div className="mb-4 ">
            <h2 className="text-xl font-bold text-blue-600 mb-4">📤 IBAN sur votre Facture</h2>

            {user.rib && !isEditingRib && (
              <div className="flex flex-col items-start gap-2 lg:w-2/3 w-full max-w-sm">
                <p className="font-semibold">{user.rib}</p>
                <button
                  onClick={() => setIsEditingRib(true)}
                  className="text-blue-600 underline hover:text-blue-800"
                >
                  Modifier
                </button>
              </div>
            )}


            {(!user.rib || isEditingRib) && (
              <form onSubmit={handleUpdaterib} className="flex flex-col gap-4 lg:w-2/3 w-full max-w-sm">
                <input
                  type="text"
                  placeholder="Commence par exemple FR..."
                  value={rib}
                  onChange={(e) => setRib(e.target.value)}
                  className="w-full border rounded px-3 py-2"
                  required
                />
                <div className="flex gap-4">
                  <button
                    type="submit"
                    className="bg-color3 text-white lg:text-lg text-base font-bold px-6 py-2 rounded-full"
                    disabled={buttonribLoading}
                  >
                    {buttonribLoading ? "Envoi..." : user.rib ? "Modifier" : "Ajouter"}
                  </button>
                  {user.rib && (
                    <button
                      type="button"
                      onClick={() => { setIsEditingRib(false); setRib(""); }}
                      className="bg-gray-400 text-white lg:text-lg text-base font-bold px-6 py-2 rounded-full"
                    >
                      Annuler
                    </button>
                  )}
                </div>
              </form>
            )}

          </div>


          <div className="w-full" id="plan">
            {user.current_plan === "basic" ? (
              <hr className="border-t border-gray-300 my-1" />
              &&
              <SubscriptionPlans token={token} codePromo={user.code_promo_utilise} />
            ) : (
              <></>
            )}
          </div>
          <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </div>
      )}

    </div>
  );
};

export default Profil;
